/**
 * Offline-safe default avatar (inline SVG data URL).
 * @param {string} displayName
 * @param {number} [size]
 * @returns {string}
 */
export function defaultAvatarDataUrl(displayName, size = 128) {
  const name = (displayName || "Player").trim();
  const parts = name.split(/\s+/).filter(Boolean);
  const initials =
    parts.length >= 2
      ? `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase()
      : (parts[0] || "P").slice(0, 2).toUpperCase();

  const hue = [...name].reduce((acc, c) => acc + c.charCodeAt(0), 0) % 360;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
  <rect width="100%" height="100%" fill="hsl(${hue},55%,42%)"/>
  <text x="50%" y="54%" dominant-baseline="middle" text-anchor="middle" fill="#fff" font-family="system-ui,sans-serif" font-size="${Math.round(size * 0.38)}" font-weight="700">${initials.replace(/&/g, "&amp;").replace(/</g, "&lt;")}</text>
</svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
